import {
  type ProviderMethodApiResponse,
  toProviderMethod,
  toProviderMethodsPage,
} from "@/adapters/provider-methods.adapter";
import {config} from "@/constants/config";
import type {TResponseRequest} from "@/interfaces/http.interface";
import httpRequest from "@/providers/http/request.http";
import {buildQueryUrl} from "@/providers/http/request.instance";
import type {CreateProviderMethodDto, ProviderMethod, UpdateProviderMethodDto} from "@/types/provider-method.types";
import type {PaginatedResult} from "@/utils/pagination";

interface ProviderMethodFilters {
  country?: string;
  provider?: string;
  operation?: string;
  active?: string;
  limit?: number;
  offset?: number;
}

export type ProviderMethodListResult = PaginatedResult<ProviderMethod>;

export const getProviderMethodsService = async (
  filters: ProviderMethodFilters = {}
): Promise<TResponseRequest<ProviderMethodListResult>> => {
  const raw = await httpRequest.get<ProviderMethodApiResponse[]>({
    url: buildQueryUrl(`${config.walletApiUrl}/bo/method-countries`, filters as Record<string, unknown>),
  });
  if (!raw.data || !raw.pagination) return {...raw, data: undefined};
  return {...raw, data: toProviderMethodsPage(raw.data, raw.pagination)};
};

export const getProviderMethodByIdService = async (id: string): Promise<TResponseRequest<ProviderMethod>> => {
  const raw = await httpRequest.get<ProviderMethodApiResponse>({
    url: `${config.walletApiUrl}/bo/method-countries/${encodeURIComponent(id)}`,
  });
  return {...raw, data: raw.data ? toProviderMethod(raw.data) : undefined};
};

export const createProviderMethodService = async (
  body: CreateProviderMethodDto
): Promise<TResponseRequest<ProviderMethod>> => {
  const raw = await httpRequest.post<ProviderMethodApiResponse>({
    url: `${config.walletApiUrl}/bo/method-countries`,
    body: body as unknown as Record<string, unknown>,
  });
  return {...raw, data: raw.data ? toProviderMethod(raw.data) : undefined};
};

export const updateProviderMethodService = async (
  id: string,
  body: UpdateProviderMethodDto
): Promise<TResponseRequest<ProviderMethod>> => {
  const raw = await httpRequest.put<ProviderMethodApiResponse>({
    url: `${config.walletApiUrl}/bo/method-countries/${encodeURIComponent(id)}`,
    body: body as unknown as Record<string, unknown>,
  });
  return {...raw, data: raw.data ? toProviderMethod(raw.data) : undefined};
};

export const toggleProviderMethodActiveService = async (
  id: string,
  isActive: boolean
): Promise<TResponseRequest<boolean>> => {
  return httpRequest.patch<boolean>({
    url: `${config.walletApiUrl}/bo/method-countries/${encodeURIComponent(id)}/active`,
    body: {is_active: isActive},
  });
};

export const deleteProviderMethodService = async (id: string): Promise<TResponseRequest<void>> => {
  return httpRequest.delete<void>({
    url: `${config.walletApiUrl}/bo/method-countries/${encodeURIComponent(id)}`,
    body: {},
  });
};
